// React & Reactstrap
import { Link } from 'react-router-dom';
import { Card, Col, Row } from 'reactstrap';
import React, { useEffect, useState } from 'react';

// Hooks
import { useLoading } from '../../hook/useLoading';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  CategoryOrganization,
  CreateCategoryOrganization,
  DeleteCategoryOrganization,
  UpdateCategoryOrganization,
} from '../../store/categoryOrganization/action';

// components
import { FloatButton } from '../../components/floatButton';
import { PageWrapper } from '../../components/pageWrapper';
import { ModalInputAnimation } from '../../components/modalInput';

// assets
import { DropdownDatatable } from '../../components/dropdownDatatable';

const CategoryOrganizations = () => {
  const [selectItem, setSelectItem] = useState('');

  const [modal_animationLeft, setmodal_animationLeft] = useState(false);

  function tog_animationLeft() {
    setSelectItem('');
    setmodal_animationLeft(!modal_animationLeft);
  }

  const dispatch = useDispatch();
  const { loadingWithTime } = useLoading();

  const { categoryOrganizations, success } = useSelector((state) => ({
    error: state.CategoryOrganization.error,
    categoryOrganizations: state.CategoryOrganization.categoryOrganizations,
    success: state.CategoryOrganization.success,
  }));

  const handleSubmit = (e) => {
    loadingWithTime(1000);
    if (selectItem === '') {
      e.preventDefault();
      dispatch(CreateCategoryOrganization(e.target.typeName.value));
      tog_animationLeft();
      // Atualizar plano
    } else {
      e.preventDefault();
      dispatch(
        UpdateCategoryOrganization({
          id: selectItem.id,
          name: e.target.typeName.value,
        })
      );
      tog_animationLeft();
    }
  };

  const handleDelete = (id) => {
    dispatch(DeleteCategoryOrganization(id));
  };

  const handleEdit = (values) => {
    setmodal_animationLeft(true);

    const { id, name } = values;
    setSelectItem({
      id: id,
      name: name,
    });
  };

  useEffect(() => {
    dispatch(CategoryOrganization());
  }, [dispatch, success]);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Tipo</span>,
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link to="#" className="currency_name">
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  return (
    <PageWrapper title={'Categorias de Organizações'}>
      <Row>
        <Col xs={12}>
          <Card>
            <DropdownDatatable
              title="Categorias de Organizações"
              titleButton="Nova categoria"
              data={categoryOrganizations ? categoryOrganizations : []}
              columns={columns}
              pagination
              persistTableHead
              perPage={10}
              isSearchRemote={false}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) => handleEdit(cellProps),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
              ]}
              handleDelete={(cellProps) => handleDelete(cellProps)}
            />
          </Card>
        </Col>
      </Row>

      <ModalInputAnimation
        toogle={tog_animationLeft}
        title={
          selectItem
            ? 'Editar Categoria de Organização'
            : 'Adicionar Categoria de Organização'
        }
        isOpen={modal_animationLeft}
        value={selectItem ? selectItem.name : ''}
        placeholder="Digite uma Categoria de Organização"
        label="Tipo de Organização"
        handleSubmit={handleSubmit}
      />

      <FloatButton handleButton={tog_animationLeft} />
    </PageWrapper>
  );
};

export default CategoryOrganizations;
